// SnowPackRemovalForm.jsx
import { useState } from "react"
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function SnowPackRemovalForm({model, setModel, target}) {
  const objsIndexes = useState([0, 1, 2, 3, 4, 5, 6])
  // When there is a change to an input element, modify the model.
  const updateValue = (val, type, varName) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''
    if(model && model.SNOWPACKS && model.SNOWPACKS[target] && model.SNOWPACKS[target][type]){
      setModel(prev => ({
        ...prev,
        SNOWPACKS:{
          ...prev.SNOWPACKS,
          [target]: {
            ...prev.SNOWPACKS[target],
            [type]: {
              ...prev.SNOWPACKS[target][type],
              [varName]: val
            }
          }
        }
      }))
    }
  }
  
  // Descriptive text and names of parameters
  const UIParams = [
    {name: 'Dplow', uiText: 'Depth at which snow removal begins'},
    {name: 'Fimelt', uiText: 'Fraction transferred out of the watershed'},
    {name: 'Fimp', uiText: 'Fraction transferred to the impervious area'},
    {name: 'Fout',  uiText: 'Fraction transferred to the pervious area'},
    {name: 'Fperv',  uiText: 'Fraction converted into immediate melt'},
    {name: 'Fsub', uiText: 'Fraction moved to another subcatchment'},
    {name: 'Scatch', uiText: 'Subcatchment name'}
  ]

  return(
    <>
    {
      model.SNOWPACKS &&
      model.SNOWPACKS[target] &&
      <>
      <Grid container style={{fontSize: '12px'}}>
        {/*
        <Grid item xs={9} style={{fontSize: '12px'}}>
          <div style={{height: '22px'}}>Depth at which snow removal begins</div>
          <div style={{height: '22px'}}>Fraction transferred out of the watershed</div>
          <div style={{height: '22px'}}>Fraction transferred to the impervious area</div>
          <div style={{height: '22px'}}>Fraction transferred to the pervious area</div>
          <div style={{height: '22px'}}>Fraction converted into immediate melt</div>
          <div style={{height: '22px'}}>Fraction moved to another subcatchment</div>
          <div style={{height: '22px'}}>Subcatchment name</div>
        </Grid>
        <Grid item xs={3}>
          {
            objsIndexes.map(v=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'REMOVAL', v)}}
                      value={model.SNOWPACKS[target].REMOVAL[v]}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
          {
            ['Scatch'].map(v=>
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'REMOVAL', v)}}
                      value={model.SNOWPACKS[target].REMOVAL[v]}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
        </Grid>
         */
        objsIndexes.map(v=>{
          return (
            <Grid container key={'snowpackremoval'+v}>
              <Grid item xs={9} style={{fontSize: '10px'}}>
                {
                  <label  style={{height: '22px'}}
                          className='editor-small'
                          key={'LID_CONTROLS_uiText'+UIParams[v].name.toString()}
                  >{UIParams[v].uiText}</label>
                }
              </Grid>
              <Grid item xs={3}>
                {
                  <>
                  {
                    v!==6 &&
                    <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'PLOWABLE', UIParams[v].name)}}
                      value={model.SNOWPACKS[target].REMOVAL[UIParams[v].name]}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
                    />
                  }
                  {
                    v===6 &&
                    <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'PLOWABLE', UIParams[v].name)}}
                      value={model.SNOWPACKS[target].REMOVAL[UIParams[v].name]}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
                    />
                  }
                  </>
                }
              </Grid>
            </Grid>
          )
        })
         
         }
      </Grid>
      </>
    }
    </>
  )
}